import { useMemo } from "react";

/**
 * Hook personalizado para manejar rutas de assets de manera consistente
 * Maneja tanto archivos en public/ como en src/
 */
export const useAssets = () => {
  const getPublicAsset = useMemo(
    () => (path: string) => {
      // Asegurar que la ruta empiece con /
      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      return normalizedPath;
    },
    []
  );

  const assets = useMemo(
    () => ({
      // Imágenes de fondo
      backgrounds: {
        login: getPublicAsset("/assets/pics/background.svg"),
      },

      // Logos
      logos: {
        latamAirlines: getPublicAsset("/assets/pics/logo-latam-airlines-w.png"),
        latamInit: getPublicAsset("/assets/pics/logo-lataminit.svg"),
        latam2: getPublicAsset("/assets/pics/DesktopNegative.svg"),
        latamCargo:
          'https://hangar-statics.appslatam.com/images/brands/latam/LATAMCargoStandard.svg',
      },

      // Iconos
      icons: {
        image: getPublicAsset("/assets/pics/image.svg"),
      },
    }),
    [getPublicAsset]
  );

  return {
    assets,
    getPublicAsset,
  };
};

export default useAssets;
